/* 
 * Single filter directive
 */
app.directive("listFilter",["$filter","$filter_text","$filter_select","$filter_date","$filter_autocomplete",function(_$filter,$text,$select,$date,$auto){
    
    var getPrefilter=function(type){
        
        var filter;
        switch (type){
            
            
            case "SELECT":
                filter=$select;
                break;
            
            case "TEXT":
                filter=$text;
                break;
                
            case "DATE":
                filter=$date;
                break;    
                
            case "AUTOCOMPLETE":
                filter=$auto;
                break;     
            
            default:
               filter=$text; 
        }
        
        return filter;
        
    };
    
    return {
        
        restrction:"E",
        require: '^^listFilters',
        scope:{
            
            type:"@",
            options:"=",//options for select type
            model:"=",//model for filter {val:'',symbol:''}
            multiple:"=",//true or false - only for select
            label:"@",
            query:"="//query returing promise -> for autocomplete type like function(search)
        },
        templateUrl:"/assets/js/angular/components/directives/filters/filter.html",
        link:function(scope,element,attrs,parentCont){
            
            scope.prefilter=getPrefilter(scope.type);
            
            scope.change=function(model){
              
              //prefiltering  
              model.value= scope.prefilter.prefilter(scope);
              
              parentCont.filterCallback(model);//send info to callback that was change
              
            };
            
            //add model to parent
            parentCont.addModel(scope.model);
        }
        
    };
    
}]);

